import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getResourceFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.resources.code.label',
      contentValue: `{{ ${entity}resource.code }}`,
      description: 'templates.resources.code.description',
    },
    {
      label: 'templates.resources.name.label',
      contentValue: `{{ ${entity}resource.name }}`,
      description: 'templates.resources.name.description',
    },
    {
      label: 'templates.resources.short_name.label',
      contentValue: `{{ ${entity}resource.short_name }}`,
      description: 'templates.resources.short_name.description',
    },
    // {
    //   label: 'templates.resources.status.label',
    //   contentValue: `{{ ${entity}resource.status }}`,
    //   description: 'templates.resources.status.description',
    // },
    {
      label: 'templates.resources.type.label',
      contentValue: `{{ ${entity}resource.type }}`,
      description: 'templates.resources.type.description',
    },
    {
      label: 'templates.resources.img_url.label',
      contentValue: `{{ ${entity}resource.img_url }}`,
      description: 'templates.resources.img_url.description',
    },
    // {
    //   label: 'templates.resources.ordering.label',
    //   contentValue: `{{ ${entity}resource.ordering }}`,
    //   description: 'templates.resources.ordering.description',
    // },
    {
      label: 'templates.resources.short_description.label',
      contentValue: `{{ ${entity}resource.short_description }}`,
      description: 'templates.resources.short_description.description',
    },
    // {
    //   label: 'templates.resources.published.label',
    //   contentValue: `{{ ${entity}resource.published }}`,
    //   description: 'templates.resources.published.description',
    // },
    // {
    //   label: 'templates.resources.publish_start_date_time.label',
    //   contentValue: `{{ ${entity}resource.publish_start_date_time }}`,
    //   description: 'templates.resources.publish_start_date_time.description',
    // },
    // {
    //   label: 'templates.resources.publish_end_date_time.label',
    //   contentValue: `{{ ${entity}resource.publish_end_date_time }}`,
    //   description: 'templates.resources.publish_end_date_time.description',
    // },
    {
      label: 'templates.resources.content.label',
      contentValue: `{{ ${entity}resource.content }}`,
      description: 'templates.resources.content.description',
    },
    {
      label: 'templates.resources.alias.label',
      contentValue: `{{ ${entity}resource.alias }}`,
      description: 'templates.resources.alias.description',
    },
    {
      label: 'templates.resources.content2.label',
      contentValue: `{{ ${entity}resource.content2 }}`,
      description: 'templates.resources.content2.description',
    },
    {
      label: 'templates.resources.calendar_type.label',
      contentValue: `{{ ${entity}resource.calendar_type }}`,
      description: 'templates.resources.calendar_type.description',
    },
    // {
    //   label: 'templates.resources.fmi.label',
    //   contentValue: `{{ ${entity}resource.fmi }}`,
    //   description: 'templates.resources.fmi.description',
    // },
    // {
    //   label: 'templates.resources.external_id.label',
    //   contentValue: `{{ ${entity}resource.external_id }}`,
    //   description: 'templates.resources.external_id.description',
    // },
    // {
    //   label: 'templates.resources.show_in_pos.label',
    //   contentValue: `{{ ${entity}resource.show_in_pos }}`,
    //   description: 'templates.resources.show_in_pos.description',
    // },
    // {
    //   label: 'templates.resources.capacity.label',
    //   contentValue: `{{ ${entity}resource.capacity }}`,
    //   description: 'templates.resources.capacity.description',
    // },
  ];
};

export const templateResource: EntityTemplateVariables = {
  fields: getResourceFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
